import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface TableToolbarProps {
	title: string;
	subtitle?: string;
	actions?: ReactNode;
}

export const TableToolbar = ({ title, subtitle, actions }: TableToolbarProps) => {
	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="flex-start"
			spacing={4}
			sx={{ mb: 3 }}
		>
			<Stack spacing={1}>
				<Typography variant="h4">{title}</Typography>
				{subtitle && (
					<Typography variant="body2" color="text.secondary">
						{subtitle}
					</Typography>
				)}
			</Stack>
			{actions && <Box>{actions}</Box>}
		</Stack>
	);
};
